import { PATH_CUENTA_DETAIL } from '../../../../navigation/navigation.module';
import { CUENTA_TYPE_PROVEEDOR } from '../../../../services/cuentas-service';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { DashboardService } from '../../../../services/dashboard-service';
import { Router } from '@angular/router';
import { MdDialogRef } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'empresas-dialog',
  templateUrl: './empresas-dialog.component.html',
  styleUrls: ['./empresas-dialog.component.scss']
})
export class EmpresasDialogComponent implements OnInit, AfterViewInit, OnDestroy {

  empresasConsignas = [];
  empresasPage = 0;
  PAGE_SIZE: number = 10;

  blockFetch: boolean = false;

  private scrollSubscriber;

  CUENTA_TYPE_PROVEEDOR = CUENTA_TYPE_PROVEEDOR;
  ASSETS_URL = environment.ASSETS_URL;

  constructor(private dashboardService: DashboardService,
              public dialogRef: MdDialogRef<EmpresasDialogComponent>,
              private router: Router) { }

  ngOnInit() {
    this.loadEmpresas();
  }

  loadEmpresas() {
    this.dashboardService.getConsignasByEmpresa(this.empresasPage, this.PAGE_SIZE)
      .subscribe(data => {
        console.log(data);
        this.empresasConsignas = [...this.empresasConsignas, ...data.ResponseData];
        this.blockFetch = false;
      });
  }

  navigateToCuenta(cuenta){
    this.dialogRef.close();
    this.router.navigate([PATH_CUENTA_DETAIL, cuenta.EmpresaId]);
  }

  ngAfterViewInit(): void {
    const content = document.getElementById('empresas-scroll');
    
    this.scrollSubscriber = Observable.fromEvent(content, 'scroll')
      .debounceTime(300)
      .map(() => content.scrollTop)
      .subscribe(x => {
        let max = content.scrollHeight - content.clientHeight;

        if ( x > max * 0.7 && !this.blockFetch){
          this.blockFetch = true;
          this.empresasPage++;
          this.loadEmpresas();
        }
      });
  }

  ngOnDestroy(): void {
    if (this.scrollSubscriber) {
      this.scrollSubscriber.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/dialog/empresas-dialog/empresas-dialog.component.ts